// extracted by mini-css-extract-plugin
export default {"wrap":"WF-z","fullWidth":"XF-z","hideOnDesktop":"YF-z","content":"ZF-z","hasOpenedNav":"_F-z","crumbsList":"aG-z","dropdownsWrap":"bG-z"};